import { useState, cloneElement, forwardRef } from 'react'
import { Typography, AccordionSummary } from '@mui/material'
import InlineEdit from '../../InlineEdit'
import { ExpandMore, DragIndicator } from '@mui/icons-material'
import MenuBar from '../../ui/menuBar/MenuBar'
import styles from './AccordionConatiner.module.scss'

export default function AccordionHeader({dragHandleProps, menuItems, changeIsExpand, text, onSetText, extraHeaderComponent }){
    const [anchorEl, setAnchorEl] = useState(null)
 
    const handleCloseMenu = () => setAnchorEl(null)

    return (
        <div className={styles['header']}>
            <div>
                <div className={styles['drag-handle']} {...dragHandleProps}>
                    <DragIndicator/>
                </div>
                {onSetText 
                    ? <InlineEdit text={text} onSetText={onSetText} maxLength={95}/>
                    : <Typography variant="h4">{text}</Typography>
                }
                {
                    extraHeaderComponent
                }
            </div>
            <div>
                {menuItems && (
                    <div className={styles['menu-bar']}>
                        <MenuBar setAnchorEl={setAnchorEl} anchorEl={anchorEl} color='icon'>
                            <div className={styles['menu-window']}>
                                {menuItems.map(item => <CloneElementMenuItem 
                                    item={item} 
                                    key={item.props.children[1] ?? item.props.children[0]} 
                                    handleCloseMenu={handleCloseMenu}
                                /> )}
                            </div>
                        </MenuBar>
                    </div>
                    )
                }
                <AccordionSummary expandIcon={<ExpandMore color="icon"/>} onClick={changeIsExpand}/>
            </div>
        </div>
    )
}

const CloneElementMenuItem = forwardRef(({item, handleCloseMenu}, ref) => {
    const onClick = () => {
        item.props.onClick()
        handleCloseMenu()
    }

    return (
        <>
            {cloneElement(item, {onClick, ref, classes:{root: styles['menu-item']}})}
        </>
    )
})